import React from 'react';
import PlanItem from '../plan-item/plan-item';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import './plan-details.css';

const PlanDetails = (props) => {
  const {
    planOverview: {
      heading,
      description,
      plan1,
      plan2,
      plan3,
    },
    customHeadingClass,
  } = props;
  return (
    <div className="plan-details-section padding-top-bottom-24">
      <SummaryDetails
        summaryTitle={heading}
        summaryText={description}
        customHeadingClass={customHeadingClass}
      />
      <div className="row plan-details">
        <div className="col-sm-12 col-md-4 plan-details-item">
          <PlanItem item={plan1} customClass="plan-lite" />
        </div>
        <div className="col-sm-12 col-md-4 plan-details-item">
          <PlanItem item={plan2} customClass="plan-mid" />
        </div>
        <div className="col-sm-12 col-md-4 plan-details-item">
          <PlanItem item={plan3} customClass="plan-max" />
        </div>
      </div>
    </div>
  );
};

export default PlanDetails;
